import Vue from 'vue'
import { RemoteInstance } from 'directus-sdk-javascript'

const directusClient = new RemoteInstance({
  url: process.env.VUE_APP_BACKEND_URL,
  version: process.env.VUE_APP_BACKEND_VERSION
})

const certificates = {
  namespaced: true,
  state: {
    certificates: []
  },
  getters: {
    list: state => state.certificates
  },
  mutations: {
    updateCertificates (state, certificates) {
      Vue.set(state, 'certificates', certificates)
    }
  },
  actions: {
    async getCertificates ({ commit }) {
      const { data } = await directusClient.getItems('certificates')
      commit('updateCertificates', data)
    }
  }
}

export default certificates
